import { render, staticRenderFns } from "./btn-secondary-active.mpx?vue&type=template&id=15e6cf43&isComponent&outputPath=components%2Fbtn-secondary-active451582f8%2Findex"
import script from "./btn-secondary-active.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-secondary-active451582f8%2Findex"
export * from "./btn-secondary-active.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-secondary-active451582f8%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports